// extracted by mini-css-extract-plugin
export default {"container":"CollectionView_container__l06oY"};